import { EventEmitter } from '@angular/core';
import { GsUsersByRolesComponent } from '../../controls/gs.users-by-roles/gs.users-by-roles.component';
import { PropertyTypes } from '../enums';
import { FormMultiselectProperty } from './formMultiselect.property';
import { FormProperty } from './formProperty';

export class FormUsersByRolesProperty extends FormProperty {
  type = PropertyTypes.UsersByRoles;
  component = GsUsersByRolesComponent;
  rolesProperty: FormMultiselectProperty;
  usersProperty: FormMultiselectProperty;
  companyGroupCode: number;
  changed = new EventEmitter<any>();

  constructor(name?: string, label?: string) {
    super(name, label);
  }
}
